import { render, staticRenderFns } from "./Vitana.vue?vue&type=template&id=20e20276"
import script from "./Vitana.vue?vue&type=script&lang=js"
export * from "./Vitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports